const translations = {
  fr: {
    spotInventory: {
      inventory: 'Inventaire',
      newPromotion: 'Nouvelle promotion',
      configuration: 'Configuration',
      monthlySpotsTotal: 'Total mensuel des spots',
      noSpotsSold: 'Aucun spot vendu',
      couldNotLoadSpotInventory: 'Une erreur est survenue lors du chargement des données.',
      configureYourInventoryTitle: 'Configurer votre inventaire',
      configureYourInventoryText: 'Vous devez configurer votre inventaire pour avoir accès à votre plage horaire et ainsi gérer plus facilement vos spots.',
      configure: 'Configurer',
    },
  },
  en: {
    spotInventory: {
      inventory: 'Inventory',
      newPromotion: 'New promotion',
      configuration: 'Configuration',
      monthlySpotsTotal: 'Monthly spot total',
      noSpotsSold: 'No spots sold',
      couldNotLoadSpotInventory: 'Could not fetch data.',
      configureYourInventoryTitle: 'Configure your inventory',
      configureYourInventoryText: 'You must configure your inventory to access your spot schedule and manage your spots more easily.',
      configure: 'Configure',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/spots/i18n/spotInventory.js